import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import TextNotice from "@/components/UI/TextNotice.vue";
import InfoCircleDark from "@/components/icons/InfoCircleDark.vue";
import WarningIcon from "@/components/icons/WarningIcon.vue";

interface Props {
	inputId?: string;
	type: 'notice' | 'error';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidationMessage',
  props: {
    inputId: {},
    type: { default: 'error' }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "validation-message",
    "aria-live": "assertive",
    id: _ctx.inputId ? `${_ctx.inputId}-validation-message` : null
  }, [
    _createVNode(TextNotice, { severity: _ctx.type }, {
      icon: _withCtx(() => [
        (_ctx.type === 'notice')
          ? (_openBlock(), _createBlock(InfoCircleDark, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.type === 'error')
          ? (_openBlock(), _createBlock(WarningIcon, { key: 1 }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["severity"])
  ], 8, _hoisted_1))
}
}

})